// Vendor Libs
import React, {useContext} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {makeStyles} from '@material-ui/core/styles';

// Contexts
import {LayoutContext} from '../../../contexts/layout-context';

const useStyles = makeStyles(theme => ({
    root: {
        transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
}));

const Content = ({className, component: Component, style, ...props}) => {
    const classes = useStyles();
    const layoutContext = useContext(LayoutContext);
    const {navVariant, navWidth, collapsible, collapsed, collapsedWidth, open, navAnchor, squeezed} = layoutContext;
    const getMargin = () => {
        if (navAnchor !== 'left') return 0;
        if ((navVariant === 'persistent' && open) || navVariant === 'permanent') {
            if (collapsible) {
                if (collapsed) return collapsedWidth;
                return navWidth;
            }
            return navWidth;
        }
        return 0;
    };
    const getWidth = () => {
        if (navVariant === 'persistent' && open) {
            if (squeezed) {
                return 'auto';
            }
            return '100%';
        }
        return 'auto';
    };
    return (
        <Component
            {...props}
            className={`${className} ${classes.root}`}
            style={{
                ...style,
                marginLeft: getMargin(),
                width: getWidth(),
            }}
        />
    );
};

Content.propTypes = {
    className: PropTypes.string,
    component: PropTypes.elementType,
    style: PropTypes.shape({}),
};
Content.defaultProps = {
    className: '',
    component: 'main',
    style: {},
};

export default Content;
